import { useContext } from 'react'
import { DarkModeContext } from '../contexts/DarkModeContext'
import Button from './Button'
import { DayIcon24, NightIcon24 } from '../icons'

export default function DarkModeButton() {
  const { darkMode, setDarkMode } = useContext(DarkModeContext)

  const testId = 'dark-mode-button'

  return (
    <Button
      type="button"
      variant="tertiary-plain"
      className="font-bold hover:!bg-cool-gray-200"
      onClick={() => setDarkMode(!darkMode)}
      data-testid={testId}
    >
      {darkMode ? (
        <NightIcon24
          className="shrink-0 text-cool-gray-200"
          data-testid={`${testId}-icon`}
        />
      ) : (
        <DayIcon24 className="shrink-0" data-testid={`${testId}-icon`} />
      )}
    </Button>
  )
}
